import { OrderDetailContent } from '@euler/app/flows/order/components/OrderDetailContent';
import { Aside } from '@euler/components/Aside';
import { adaptiveWrapperOptions } from '@euler/functions/navigationOptionsBuilder';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { CardStyleInterpolators } from '@react-navigation/stack';
import { ScrollView } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const OrderDetailScreen = wrapNavigatorScreen(
  () => {
    const { bottom } = useSafeAreaInsets();

    return (
      <Aside dismissible>
        <ScrollView contentContainerStyle={{ paddingBottom: bottom }}>
          <OrderDetailContent />
        </ScrollView>
      </Aside>
    );
  },
  adaptiveWrapperOptions({
    cardStyleInterpolator: CardStyleInterpolators.forScaleFromCenterAndroid,
  }),
);
